import React from "react";
import {OverlayView} from "react-google-maps";
import Button from "react-bootstrap/Button";
import {useTranslation} from 'react-i18next';
import {MapMarkerText, BubbleContainer, BubbleTriangle, TriangleContainer, ImageContainer /* CloseButton */} from "../../../AssetListScreenStyles";
import './style.css';

interface Props {
    position?: { lat: number, lng: number }
    image?: string,
    name?: string,
    technicalName?: string,
    chineseName?: string,
    englishName?: string,
    price?: number,
    currency?: string,
    onSelectAsset?: () => void,
    // onClose: () => void,
}

export const MapInfoBubble: React.FunctionComponent<Props> = props => {
    const { t } = useTranslation();
    const getPixelPositionOffset = (pixelOffset: {x: number, y: number}) => (width: number, height: number) => ({
        x: -(width / 2) + pixelOffset.x,
        y: -(height / 2) + pixelOffset.y
    });
    return (
        <OverlayView
            key={Math.random()} // fix overlayMouseTarget null error https://github.com/tomchentw/react-google-maps/issues/482
            position={props.position}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            // getPixelPositionOffset={getPixelPositionOffset(props.markerPixelOffset)}
            getPixelPositionOffset={getPixelPositionOffset({ x: 0, y: -85 })}
        >
        <>
            <BubbleContainer>
                <div style={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#d8d8d8',
                    ...(!!props.image ? {
                        backgroundImage: `url("${props.image}")`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    } : {})
                }}/>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <div style={{ padding: 8 }}>
                        <MapMarkerText isTitle={true}>
                            {`${props.name} ${props.technicalName ? props.technicalName.toUpperCase() : ''}`}
                        </MapMarkerText>
                        <MapMarkerText bold>
                            {props.chineseName || props.englishName}
                        </MapMarkerText>
                        <MapMarkerText>
                            {`${t('donationAmount')}: ${props.currency}${!!props.price && props.price.toLocaleString()}`}
                        </MapMarkerText>
                    </div>
                    <Button
                        onClick={() => {
                            console.log('hi', props)
                            props.onSelectAsset && props.onSelectAsset()
                        }}
                        variant={"primary"}
                        style={{ 
                            zIndex: 5,
                            backgroundColor: '#2c3e50',
                            borderColor: '#2c3e50',
                            width: '20%',
                            fontFamily: 'Rambla',
                            fontSize: '12px',
                            padding: 0,
                            paddingTop: 2,
                        }}
                    >
                        {t('select')}
                    </Button>
                </div>
            </BubbleContainer>
            <TriangleContainer>
                <BubbleTriangle/>
            </TriangleContainer>
        </>
        </OverlayView>
    );
};

  export default MapInfoBubble;